/* eslint-disable springload/react/prefer-stateless-function */
/* eslint-disable class-methods-use-this */
/* eslint-disable springload/react/prop-types */

import { h, Component } from 'preact';

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

import SearchResultCard from './SearchResultCard';

class SearchResults extends Component {
    render() {
        const { loadingResults, hits } = this.props;
        const noResults = hits.length === 0;
        if (loadingResults || noResults) return null;
        return (
            <div className="grey-full-width">
                <div className="gutters">
                    <div className="page">
                        <ul
                            className="search-results-list no-bullets"
                            data-search-results-list
                        >
                            {hits.map(hit => {
                                return <SearchResultCard hit={hit} />;
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchResults;
